const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
const SET_MOKTA_USER = 'SET_MOKTA_USER';

export default {
    SET_REDIRECT_URL,
    SET_MOKTA_USER
};
